/**
 * Engangsjustering av 2026-mål: GEEK som ble jobbet før 2026 trekkes ut av
 * årets måloppnåelse. Avslutningsregelen (`completed_at`) er uendret — dette
 * er ikke en ny periodiseringsformel.
 *
 * Godkjent 26. august 2026 (Daniel/Terje). Timevektet andel før 2026, låst
 * mot prod 24. august 2026. 2025 restateres ikke.
 */

export const GEEK_MAAL_ADJUSTMENT_YEAR = 2026;

/** Prosjektkode → kroner som ikke skal telle mot 2026-målene. */
export const GEEK_MAAL_EXCLUDE_KR = {
  "390": 739_695,
  "463": 198_798,
  "289": 190_741,
  "498": 129_482,
  "527": 71_991,
  "528": 52_451,
  "522": 36_258,
  "520": 33_739,
  "361": 21_487,
  "533": 10_201,
  "539": 980,
} as const satisfies Record<string, number>;

export const GEEK_MAAL_EXCLUDE_TOTAL_KR = Object.values(GEEK_MAAL_EXCLUDE_KR).reduce(
  (sum, n) => sum + n,
  0,
);

export function geekForMaal(
  project: { project_code?: string | null; bf_actual?: number | null },
  year: number,
): number {
  const raw = Number(project.bf_actual ?? 0);
  if (year !== GEEK_MAAL_ADJUSTMENT_YEAR) return raw;
  const code = project.project_code?.trim();
  if (!code) return raw;
  const exclude = GEEK_MAAL_EXCLUDE_KR[code as keyof typeof GEEK_MAAL_EXCLUDE_KR];
  if (exclude == null) return raw;
  return Math.max(0, raw - exclude);
}
